import request from 'utils/request'

export function loadSystems(data) {
  return request('admin/devices', {
    method: 'POST',
    data
  }).then(([body]) => body)
}

export function loadLastVersions() {
  return request('admin/lastversions', {
    method: 'GET'
  }).then(([body]) => body)
}

export function loadSystem(deviceId) {
  return request(`admin/devices/${deviceId}`, {
    method: 'GET'
  }).then(([body]) => body)
}

export function updateResetSystem(data, deviceId) {
  return request(`admin/reset/${deviceId}`, {
    method: 'PUT',
    data: data
  }).then(([body]) => body)
}

export function getSystemMeasurementsByTypeNew(data) {
  return request(`systems/mtype`, {
    method: 'POST',
    data
  }).then(([body]) => body)
}

export function deleteSystem(id) {
  return request(`admin/delsystem/system/${id}`, {
    method: 'DELETE'
  })
}

export function deleteSystemData(id) {
  return request(`admin/delsystem/data/${id}`, {
    method: 'DELETE'
  })
}

export function deleteSystemFromUser(id) {
  return request(`admin/delsystem/fromuser/${id}`, {
    method: 'PUT'
  })
}

export function syncAirtableInformation() {
  return request(`admin/airtable`, {
    method: 'GET'
  }).then(([body]) => body)
}

export function chatarrizarDevices(data) {
  return request(`admin/chatarrizar`, {
    method: 'POST',
    data: data
  }).then(([body]) => body)
}

export function checkChatarrizarDevices(data) {
  return request(`admin/chatarrizar/state`, {
    method: 'POST',
    data: data
  }).then(([body]) => body)
}

export function migrateDevices(data) {
  return request(`admin/migrate`, {
    method: 'POST',
    data: data
  }).then(([body]) => body)
}

export function checkMigrateDevices(data) {
  return request(`admin/migrate/state`, {
    method: 'POST',
    data: data
  }).then(([body]) => body)
}
